/* eslint-disable @typescript-eslint/no-explicit-any */
import { ahuBoardApi } from 'app/services/ahuBoardApi';

/**
 * Phase 6 Vendor-Port W3 — ENERGY WHEEL selector data layer (§33.3).
 *
 * The energy_wheel selector's only WRITES are:
 *   1. RATE  → POST /api/v1.0/rating/ {part:'erwheel', ...} — the EXTERNAL
 *      vendor dispatch, handled by the SHARED useRatingDispatch (ratingApi).
 *      NOT re-declared here.
 *   2. SELECT (apply) → current_model.set(models_field) — the component
 *      auto-save PATCH ahu/energy_wheels/<id> (the §49.2 engine / the form
 *      shim). The selector does NOT own a separate write endpoint; on Select it
 *      pushes models_field through the form shim (model.set→auto-save) exactly
 *      as legacy current_model.set does. So this file declares only the typed
 *      READS the selector needs that aren't already in ahuComponentFormsApi.
 *
 * READS reused from ahuComponentFormsApi (getMasterListByUrl) — air_streams,
 * flow_types, fan_locations, speeds, and the master-branch param lists. Only the
 * notes GET (which returns {notes:[...]}) gets a typed query here.
 *
 * ★ DATA-SAFETY: every endpoint here is a GET. The only mutating path (Select)
 * routes through the existing component auto-save (userArmed-gated in the
 * selector). The read-only SMOKE fires GETs only → 0 mutating + 0 /rating/.
 */

export interface EwNote {
  note: string;
  [key: string]: unknown;
}

export const energyWheelSelectorApi = ahuBoardApi.injectEndpoints({
  endpoints: (builder) => ({
    // er_wheel rating notes (legacy NotesCollection). Response shape is loose:
    // an array of {note} rows OR {notes:[...]} OR {results:[...]}.
    getEnergyWheelNotes: builder.query<EwNote[], string>({
      query: (url) => url,
      transformResponse: (res: unknown): EwNote[] => {
        if (Array.isArray(res)) return res as EwNote[];
        const o = res as { notes?: EwNote[]; results?: EwNote[] } | null;
        return o?.notes ?? o?.results ?? [];
      },
      keepUnusedDataFor: 24 * 60 * 60,
    }),
  }),
  overrideExisting: false,
});

export const { useGetEnergyWheelNotesQuery } = energyWheelSelectorApi;
